var acc = document.getElementsByClassName("accordionkw");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panelkw = this.nextElementSibling;
    if (panelkw.style.maxHeight) {
      panelkw.style.maxHeight = null;
    } else {
      panelkw.style.maxHeight = panelkw.scrollHeight + "px";
    } 
  });
}
